import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import shortKey from 'vue-three-shortkey';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import App from './App.vue';
import router from './router';
import store from './store';

import './index.css';
import './assets/tailwind.css';
import archbee from './mixins/archbee';

const app = createApp(App);
app.use(router);
app.use(store);
app.use(shortKey);
app.use(VueGtag, {
  config: { id: 'G-6PM52P4VBX' },
  appName: 'SparkLayer Dashboard',
  pageTrackerScreenviewEnabled: true,
}, router);

app.mixin(archbee);

const { host } = window.location;
if (host === 'app.sparklayer.io' || host === 'app.dev.sparklayer.io') {
  Sentry.init({
    app,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb?.data?.url?.includes('clarity.ms')) {
        return null;
      }
      return breadcrumb;
    },
    dsn: 'https://b2cd1b9778ed4f8abe25362246e2c35f@o932531.ingest.sentry.io/5881317',
    environment: host,
    ignoreErrors: [
      // Ignore network errors which are likely caused by user's unreliable
      // network connection
      'error loading dynamically imported module',
      'Failed to fetch dynamically imported module',
      'Load failed',
      'NetworkError',
      'Unable to preload CSS',

      // https://stackoverflow.com/a/50387233
      'ResizeObserver loop limit exceeded',
    ],
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [host, /^\//],
      }),
    ],
    logErrors: true,
    // __SENTRY_RELEASE__ is statically replaced at build time by Vite
    // eslint-disable-next-line no-undef
    release: __SENTRY_RELEASE__,
    tracesSampleRate: 0.1,
  });
}

app.mount('#app');
